import FrameComponent from "./FrameComponent";

const Splash0 = () => {
  return (
    <div className="w-full relative bg-[#f2ece3] overflow-hidden flex flex-col items-start pt-[74px] px-[100px] pb-3 box-border gap-[62px] leading-[normal] tracking-[normal] text-left text-base text-[#353434] font-[Mingzat] lg:pl-[50px] lg:pr-[50px] lg:box-border mq750:gap-[31px] mq750:pl-[25px] mq750:pr-[25px] mq750:box-border mq450:gap-[15px]">
      <main className="flex items-start gap-[108px] max-w-full lg:flex-wrap mq750:gap-[54px] mq450:gap-[27px]">
        <img
          className="h-[800px] flex-1 relative rounded-[20px] max-w-full overflow-hidden object-cover min-w-[390px] mq750:min-w-full"
          loading="lazy"
          alt=""
          src="./Rectangle-6@2x.png"
        />
        <FrameComponent />
      </main>
      <div className="flex items-start py-0 px-[463px] box-border max-w-full lg:pl-[231px] lg:pr-[231px] lg:box-border mq750:pl-[115px] mq750:pr-[115px] mq750:box-border mq450:pl-5 mq450:pr-5 mq450:box-border">
        <div className="relative">
          {`2026 |  | `}
          <span className="[text-decoration:underline]">Terms of Use</span>
          {` | `}
          <span className="[text-decoration:underline]">Privacy Policy</span>
        </div>
      </div>
    </div>
  );
};

export default Splash0;
